import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LEAVE_MANAGEMENT_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const leaveManagementServiceApi = createApi({
  reducerPath: "leaveManagementServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: LEAVE_MANAGEMENT_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: [
    "GetLeaveTypeList",
    "GetLeaveTypeListDetails",
    "GetOtherSettingData",
    "GetLeaveProrateEmployeeList",
    "GetLeaveProrateDetails",
    "GetEmployeeProrateList",
    "GetApprovalSettingList",
    "GetLeaveApplicationList",
    "GetLeaveApplicationDetails",
    "GetLeaveAdjustmentLog",
    "GetLeaveAdjustmentList",
    "GetLeaveAdjustmentDetails",
  ],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
